export const advancedData = ({ modelAdvanced }, { modelId }) =>
  modelAdvanced.byId[modelId];

export const advancedFilters = ({ modelAdvanced }) =>
  modelAdvanced.filters;
